import { ref } from 'vue'

const isVisible = ref(false)
const message = ref('')
let timer: number | null = null
const DURATION = 3000

// トースト通知の表示・非表示を管理する処理
export function useToast() {
  const show = (msg: string) => {
    message.value = msg
    isVisible.value = true
    if (timer) clearTimeout(timer)
    timer = window.setTimeout(() => {
      isVisible.value = false
      timer = null
    }, DURATION)
  }
  const hide = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    isVisible.value = false
  }
  return { isVisible, message, show, hide }
}
